import { Form as FormRoot } from 'formik';
import { Box, Stack } from '@mui/material';
import styled from 'styled-components';

export const Title = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 0;
`;

export const Content = styled(Stack)`
  margin-bottom: 25px;
`;

export const Description = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
  margin: 0;
  color: #212121;
  font-size: 16px;
`;

export const Reason = styled(Box)`
  color: #b30303;
  width: 100%;
  word-wrap: break-word;
`;

export const Form = styled(FormRoot)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;
